export const frontmatter = {
    "draft": true,
    "title": "Webhooks",
    "description": "Configuration and use of webhooks in OnnIA.",
    "sidebar_label": "Webhooks",
    "sidebar_group": "reference",
    "sidebar_order": 3
}

export const toc = []